import { Link as WaspRouterLink, routes } from "wasp/client/router";
import { ResetPasswordForm } from "wasp/client/auth";
import { AuthPageLayout } from "../AuthPageLayout";

// Match the appearance with Login/Signup pages
const authAppearance = {
  colors: {
    brand: "#EC4899", // primary pink-500
    brandAccent: "#F9A8D4", // secondary pink-300
    submitButtonText: "white",
    inputBackground: "white",
    inputBorder: "#F5D0FE", // stroke color
    inputBorderHover: "#F9A8D4", // secondary color
    inputBorderFocus: "#EC4899", // primary color
    dividerBackground: "#F5D0FE", // stroke color
  },
  borderRadii: {
    inputBorderRadius: "6px",
    buttonBorderRadius: "6px",
  },
};

export function PasswordResetPage() {
  return (
    <AuthPageLayout>
      <ResetPasswordForm appearance={authAppearance} />
      <br />
      <span className="text-sm font-medium text-neutral-900">
        If everything is okay,{" "}
        <WaspRouterLink
          to={routes.LoginRoute.to}
          className="underline text-pink-500 hover:text-pink-400"
        >
          go to login
        </WaspRouterLink>
      </span>
    </AuthPageLayout>
  );
}
